import { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import { useFetchAll } from "../../../custom/FetchApiHook";
import SidebarField from "../../../components/Sidebar/SidebarField";
import { FormField } from "../../../components/FormField";
import SelectDropdown from "../../../components/Dropdown/SelectDropdown";
import { MultiSelectDropDown } from "../../../components/Dropdown";
import Button from "../../../components/Button";
import TextInput from "../../../components/TextInput";
import ToggleField from "../../../components/ToggleField";
import { InventoryApi } from "../../../apis/inventory.api";

function AddStockOnHandReport({ currentItems, getAllData, open, handleClose }) {
  const rolesData = []; //useFetchAll(() => AuthApi.getRoles());
  const ComponentTypesData = []; //useFetchAll(() => ComponentTypeApi.getAllComponentTypesData());
  const ComponentData = []; //useFetchAll(() => ComponentApi.getActiveComponents());
  const allPermissions = []; //useFetchAll(() => PermissionApi.getAllPermissionsData());
  const [componentOptions, setComponentOptions] = useState();
 

  const initialValues = {
    roleId: currentItems?.roleId?._id || "",
    componentType: currentItems?.componentType?._id || "",
    component: currentItems?.component?._id || "",
    permissions:
      currentItems?.permissions?.map((item) => item.permissionId) || [],
    active: currentItems?.active || false,
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Data", values);

    const permissionPayload = [];
    allPermissions.value?.data?.forEach((item) => {
      if (values?.permissions.includes(item._id)) {
        permissionPayload.push({
          permissionName: item.name,
          permissionId: item._id,
        });
      }
    });

    console.log("permissionPayload", permissionPayload);

    const payload = {
      roleId: values.roleId,
      component: values.component,
      componentType: values.componentType,
      permissions: permissionPayload,
      active: values.active,
    };

    // try {
    //   console.log('values', payload);
    //   // Logic for creating or updating the role and permissions
    //   const response = currentItems?._id
    //     ? await RolePermissionApi.updateRolePermission(payload, currentItems._id)
    //     : await RolePermissionApi.createRolePermission(payload);

    //   // getAllData();
    //   toast.success(currentItems?._id ? 'Role And Permission updated' : 'Role And Permission created');
    // } catch (err) {
    //   console.error(err);
    //   toast.error(err?.message);
    // } finally {
    //   resetForm();
    //   handleClose();
    // }
  };


  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          //   validationSchema={RolePermissionsSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id
                    ? "Update Role & Permissions"
                    : "Add New Role & Permissions"
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button
                    text={currentItems?._id ? "Update" : "Submit"}
                    type="submit"
                  />
                }
              >
                <FormField label="Role" tooltip="Enter role name">
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.roleId}
                    inputName="role"
                    placeholder="Select Role"
                    options={rolesData?.value?.data || []}
                    optionLabel="name"
                    optionValue="_id"
                    handleFilter={(name, v) => setFieldValue("roleId", v)}
                  />
                  <ErrorMessage name="roleId" component="p" className="error" />
                </FormField>

                <FormField
                  label="Component Type"
                  tooltip="Select component type"
                >
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.componentType}
                    inputName="componentType"
                    placeholder="Select Component Type"
                    options={ComponentTypesData.value?.data || []}
                    optionLabel="name"
                    optionValue="_id"
                    handleFilter={(name, value) => {
                      const ComponentOp = ComponentData.value.data.filter(
                        (v) => v?.componentType?._id === value
                      );
                      console.log(ComponentOp);

                      setComponentOptions(ComponentOp);
                      setFieldValue("componentType", value);
                    }}
                  />
                  <ErrorMessage
                    name="componentType"
                    component="p"
                    className="error"
                  />
                </FormField>

                <FormField
                  label="Components"
                  tooltip="Enter components separated by commas"
                >
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.component}
                    inputName="component"
                    placeholder="Select Components"
                    options={
                      currentItems?._id
                        ? ComponentData.value.data.filter(
                            (v) =>
                              v?.componentType?._id ===
                              currentItems?.componentType?._id
                          )
                        : componentOptions || []
                    }
                    optionLabel="name"
                    optionValue="_id"
                    handleFilter={(name, v) => setFieldValue("component", v)}
                  />
                  <ErrorMessage
                    name="component"
                    component="p"
                    className="error"
                  />
                </FormField>

                <FormField
                  label="Allowed Permissions"
                  tooltip="Enter allowed permissions"
                >
                  <MultiSelectDropDown
                    sx={{ width: "100%" }} // Optional custom style
                    name={`permissions`}
                    value={values.permissions}
                    options={allPermissions.value?.data || []}
                    placeholder="Select options"
                    handleMultiselectChange={(e) => {
                      console.log(e);
                      setFieldValue("permissions", e);
                    }}
                    optionLabel="name"
                    optionValue="_id"
                  />
                  <ErrorMessage
                    name="permissions"
                    component="p"
                    className="error"
                  />
                </FormField>
                <div>
                  <ToggleField
                    text={values.active ? "Enabled" : "Disabled"}
                    name="active"
                    value={values.active}
                    toggaleHandleChange={(e) => {
                      console.log("v", e.target.value);

                      setFieldValue("active", e.target.value);
                    }}
                  />
                  <ErrorMessage name="active" component="p" className="error" />
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddStockOnHandReport;
